// visitedPaths.js
export const VISITED_PATHS = {
  // ============================
  // 🌎 WORLD / UNITED STATES
  // ============================
  "united states": "/map/usa",
  unitedstates: "/map/usa",
  usa: "/map/usa",
  us: "/map/usa",
  newjersey: "/map/newjersey",
 

  // ============================
  // 🇵🇷 PUERTO RICO (REGION)
  // ============================
    puertorico: "/map/puertorico",
  pr: "/map/puertorico",
  borinquen: "/map/puertorico",

  // ============================
  // 🇵🇷 PUERTO RICO — MUNICIPALITIES
  // ============================
  aguadilla: "/travel/puertorico/aguadilla",
  arecibo: "/travel/puertorico/arecibo",
  caborojo: "/travel/puertorico/caborojo",
  guanica: "/travel/puertorico/guanica",
  utuado: "/travel/puertorico/utuado",
  jayuya: "/travel/puertorico/jayuya",
  isabela: "/travel/puertorico/isabela",
  lajas: "/travel/puertorico/lajas",
  sanjuan: "/travel/puertorico/sanjuan",
  vieques: "/travel/puertorico/vieques",
  rincon: "/travel/puertorico/rincon",
  aguada: "/travel/puertorico/aguada",
  anasco: "/travel/puertorico/anasco",
  adjuntas: "/travel/puertorico/adjuntas",
  sansebastian: "/travel/puertorico/sansebastian",

 

  
 

  // ============================
  // 🇺🇸 USA — COLORADO (REGION)
  // ============================
  
  colorado: "/map/colorado",
  
 
puertoricobutton: "/map/puertorico",

  // ============================
  // 🇺🇸 COLORADO — CITIES & TOWNS
  // ============================
  aspen: "/travel/usa/colorado/aspen",
  buenavista: "/travel/usa/colorado/buenavista",
  canyoncity: "/travel/usa/colorado/canyoncity",
  coloradosprings: "/travel/usa/colorado/coloradosprings",
  denver: "/travel/usa/colorado/denver",
  frisco: "/travel/usa/colorado/frisco",
  georgetown: "/travel/usa/colorado/georgetown",
  golden: "/travel/usa/colorado/golden",
  glenwoodsprings: "/travel/usa/colorado/glenwoodsprings",
  idahosprings: "/travel/usa/colorado/idahosprings",
  manitousprings: "/travel/usa/colorado/manitousprings",
  morrison: "/travel/usa/colorado/morrison",
  mosca: "/travel/usa/colorado/mosca",
  ouray: "/travel/usa/colorado/ouray",
  rifle: "/travel/usa/colorado/rifle",
  steamboat: "/travel/usa/colorado/steamboat",
  telluride: "/travel/usa/colorado/telluride",
  vail: "/travel/usa/colorado/vail",
   breckendridge: "/travel/usa/colorado/breckenridge",
   fruita: "/travel/usa/colorado/fruita",
   grandlake: "/travel/usa/colorado/grandlake",

  // ============================
  // 🇺🇸 OTHER STATES (IF USED)
  // ============================
  idaho: "/travel/idaho",
  nevada: "/travel/nevada",
  //oregon: "/travel/oregon",
  oregon: "/map/oregon",
  oregoncoast: "/travel/oregoncoast",
  oregoncolumbiariver: "/travel/oregoncolumbiariver",
  oregonsilverfalls: "/travel/oregonsilverfalls",
  utah: "/travel/utah",
  wyoming: "/travel/wyoming",
  southdakota: "/travel/southdakota",
  arizona: "/travel/arizona",
  capemay: "/travel/capemay",
};
